export default __webpack_public_path__ + "static/media/rk9.c2e592a8.png";